import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontSize,
  standardTransition,
} from '../../styles';
import { Link } from './Link';

const commonButtonStyles = () => {
  return css`
    display: inline-block;
    padding: 10px 16px;
    color: ${standardColours.white};
    ${fontSize(16)};
    line-height: 1.6;
    background-color: ${({ alt }) =>
      alt ? brandColours.tertiary : brandColours.primary};

    ${minBreakpointQuery.tiny`
      padding: 12px 18px;
    `}

    ${minBreakpointQuery.small`
      padding: 14px 20px;
      ${fontSize(18)};
    `}

    &:disabled {
      opacity: 0.8;
    }

    ${({ arrow }) => {
      if (arrow) {
        return css`
          span {
            position: relative;
            display: block;
            padding-right: 24px;

            &:after {
              content: '➔';
              position: absolute;
              top: 50%;
              right: 0;
              color: inherit;
              ${fontSize(16)};
              transform: translateY(-50%);
              transition: ${standardTransition('transform')};
            }
          }

          &:hover {
            span {
              &:after {
                transform: translateX(3px) translateY(-50%);
              }
            }
          }
        `;
      }
    }}
  `;
};

const HttpsRegex = /https?:\/\//gi;

const StyledButton = styled.button`
  ${commonButtonStyles()};
`;

const StyledButtonInternalLink = styled(Link)`
  ${commonButtonStyles()};
`;

const StyledButtonExternalLink = styled.a`
  ${commonButtonStyles()};
`;

export const Button = ({ alt, arrow, children, ...props }) => {
  const { href, to, ...buttonProps } = props;
  if (href) {
    buttonProps.href = href;
  } else if (HttpsRegex.test(to)) {
    buttonProps.href = to;
    buttonProps.target = '_blank';
  } else {
    buttonProps.to = to;
  }

  const ButtonComponent = buttonProps.href
    ? StyledButtonExternalLink
    : buttonProps.to
      ? StyledButtonInternalLink
      : StyledButton;

  return (
    <ButtonComponent alt={alt} arrow={arrow} {...buttonProps}>
      <span>{children}</span>
    </ButtonComponent>
  );
};
